import { requests } from './baseServices'

export const WinbizServices = {       
    /*sendViaEmail: (data) => requests.put(`api/invoices/send`, data),
    cancel: (id, isCreditNote) => requests.delete(`api/invoices/cancel/${id}/${isCreditNote}`),*/
    syncInvoice: (id) => requests.put(`api/winbiz/invoice/${id}`),
    syncInvoices: (id) => requests.post(`api/winbiz/invoices/${id}`),
    syncWages: (id) => requests.post(`api/winbiz/wages/${id}`),
    syncExpenses: (year,month,developerId) => requests.post(`api/winbiz/expenses/${year}/${month}/${developerId}`),
    syncExpensesAccounting: (year, month, developerId) => requests.post(`api/winbiz/expenses/accounting/${year}/${month}/${developerId}`),
    syncExpensesSalary: (year, month, developerId) => requests.post(`api/winbiz/expenses/salary/${year}/${month}/${developerId}`),
    syncExpensesPurchasing: (year, month, developerId) => requests.post(`api/winbiz/expenses/purchasing/${year}/${month}/${developerId}`),
    getConfig: () => requests.get(`api/winbiz/`),
    setConfig: (data) => requests.put(`api/winbiz/`,data)
};